
import { defineComponent } from 'vue'
import { NDescriptions, NDescriptionsItem, NButton } from 'naive-ui';
import { mapState, mapStores } from 'pinia';

import { useAuthStore } from "~/store/auth.store";
import componentBase from '../../components/component-base';

export default defineComponent({

    extends: componentBase,

    components: {
        NDescriptions,
        NDescriptionsItem,
        NButton,
    },

    computed: {
        ...mapState(useAuthStore, ['user']),
        ...mapStores(useAuthStore),
    },

    methods: {
        async deleteAccount(): Promise<void> {

            const confirmed: boolean = await this.$confirm(this.$t('preferences.my-account.delete_account'), this.$t('preferences.my-account.confirm_delete_account'))

            if(!confirmed) {
                return;
            }

            try {
                await this.authStore.deleteAccount();
                this.success(this.$t('preferences.my-account.delete_account_success'))
                await this.$router.push({ name: 'login' });

            } catch(e) {
                this.showUnhandledError(this.$t('preferences.my-account.delete_account_failure'));
            }

            
        },
    },
})
